// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__gPTxa","location":"Header_location__1FAKO"};